import React from 'react';
import { graphql } from 'gatsby';
import Divider from '@solid-ui-components/Divider';
import { normalizeBlockContentNodes } from '@blocks-helpers';
import ContactCards from '@solid-ui-blocks/ContactsCards/ContactCards';
import BasePage from '@elegantstack/solid-ui-blocks/src/BasePage';
import ContentText from '@solid-ui-components/ContentText';
import LayoutWrapper from '@solid-ui-layout/LayoutWrapper';
import styles from './_styles';
import { Box } from 'theme-ui';

const ContactsPage = (props) => {
  const {
    data: { allBlockContent },
    location: { pathname },
  } = props;
  const content = normalizeBlockContentNodes(allBlockContent?.nodes);

  return (
    <BasePage
      description={
        'Get in touch with TARGPatrol for support, feedback, or collaboration opportunities. Our team is here to answer your questions and provide assistance.'
      }
      title={'Contacts'}
      pathname={pathname}
      {...props}>
      <LayoutWrapper divider={<Divider />}>
        <Box sx={styles.headingBetweenBlocks}>
          <ContentText content={content['first-heading']?.text} />
          <ContactCards
            content={content['contacts']}
            variants={['blue', 'purple', 'yellow']}
          />
        </Box>
        <iframe style={{width: '100%', height: '966px'}} src={'https://us17.list-manage.com/contact-form?u=bfd305cbdd5184ba3723cdf2c&form_id=2d4ed563861d8199d6ec986caa8deebc'}/>
      </LayoutWrapper>
    </BasePage>
  );
};

export const query = graphql`
  query contactsPageTargpatrolEnBlockContent {
    allBlockContent(filter: { page: { in: ["targpatrol-en/contacts"] } }) {
      nodes {
        ...BlockContent
      }
    }
  }
`;
export default ContactsPage;
